import './TransparentBlocker.scss';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * A component for blocking user interaction on the screen
 */
const defaultProps = {
  show: false,
  isFullScreen: false,
};

export default function TransparentBlocker(props) {
  const { show, isFullScreen } = { ...defaultProps, ...filterUndefined(props) };
  return show ? <div className={`transparent-blocker ${isFullScreen ? 'full-screen' : ''}`} /> : '';
}
